import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "checkbox" }
const _hoisted_2 = ["id", "disabled"]
const _hoisted_3 = ["for"]

import { v4 as uuid } from 'uuid';
import { computed, toRefs } from 'vue';

interface Props {
  modelValue: boolean;
  disabled?: boolean;
  label?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomCheckbox',
  props: {
    modelValue: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const id = uuid().toString();

const props = __props;

const { disabled, label } = toRefs(props);

const emit = __emit;

const checked = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      id: 'checkbox-' + _unref(id),
      class: "checkbox__input",
      type: "checkbox",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event)),
      disabled: _unref(disabled)
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, checked.value]
    ]),
    (_unref(label))
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: 'checkbox-' + _unref(id),
          class: "checkbox__label"
        }, _toDisplayString(_unref(label)), 9, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})